"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenLogin = exports.Name = void 0;
const Name = exports.Name = 'open-login';
const OpenLogin = exports.OpenLogin = Name;

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- Data can be extended in the future
//# sourceMappingURL=event.js.map